/**
 * @fileoverview GET handler for the "/apps/:app_id/push_credential" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppIdPushCredential } from "./constants";
import type { AppsAppIdPushCredentialResult } from "./types";

export const getAppsAppIdPushCredential = reactQueryFetcherAdapter(
  appsAppIdPushCredential,
  (signal: AbortSignal, appId: string): Promise<AppsAppIdPushCredentialResult> => {
    return fetch(`/apps/${appId}/push_credential`, "GET", {}, { signal });
  }
);
